import axios from 'axios/index';
import { DELETE_AGENT } from '../../utils/constants';

const deleteAgent = async (hash, id) => {

    return await axios.delete(DELETE_AGENT(id),
        { // <= id here
            data: {},
            headers: {
                "Accept": "application/json",
                "Accept-language": "bg",
                "Authorization": hash,
            }
        }).then(resp => {
            return resp;
        }).catch(err => {
            console.error(err)
        })
}

export default deleteAgent;